import { getKarateUi } from "@/i18n/karateUiI18n.js";

/**
 * Libellé statut préparation Phase 1 localisé — BT-028-R2.
 * @param {ReturnType<import('@/data/dataStore.js').getHanshiDashboardStats>} stats
 * @param {'fr'|'en'} locale
 */
export function getPhase1PrepStatusLabel(stats, locale = "fr") {
  const ui = getKarateUi(locale);
  if (stats.dojosOfficial >= stats.targetDojos) {
    return ui.prepStatus.dojosComplete;
  }
  if (stats.dojosDemo > 0 && stats.dojosOfficial === 0) {
    return ui.prepStatus.demoOnly;
  }
  return ui.prepStatus.awaitingClient;
}

/** @param {'replace'|'merge'|'replace_official'} mode @param {'fr'|'en'} locale */
export function getImportModeLabel(mode, locale = "fr") {
  const ui = getKarateUi(locale);
  return ui.importModes[mode] ?? mode;
}

/** @param {keyof import('@/data/types.js').DOCUMENT_VISIBILITY_LABELS} key @param {'fr'|'en'} locale */
export function getVisibilityLabel(key, locale = "fr") {
  const ui = getKarateUi(locale);
  return ui.visibility[key] ?? key;
}

/**
 * Avertissement visibilité document localisé — BT-028-R2.
 * @param {string} visibilite
 * @param {string} titre
 * @param {'fr'|'en'} locale
 */
export function getDocumentVisibilityWarningLocalized(visibilite, titre = "", locale = "fr") {
  const ui = getKarateUi(locale);
  if (visibilite === "public" && /protocole|black dragon|rituel|symbolisme/i.test(titre)) {
    return ui.documents.sensitiveWarning;
  }
  if (visibilite === "public") return null;
  if (visibilite === "a_valider") return ui.documents.unvalidatedWarning;
  return null;
}
